import React, { useContext } from 'react';
import { IComponent } from '../../component';
import './ImageTips.scss';
import { ThemeContext } from '../../store/ThemeProvider';

const ImageTips = function(props: IComponent) {
  const { h1Color, h2Color, componentColor, backgroundColor } = useContext(
    ThemeContext
  );

  return (
    <div className="imagetips" style={{ backgroundColor: componentColor }}>
      <div className="h1 header" style={{ color: h2Color }}>
        <div className="line" />
        <span style={{ color: h1Color, margin: 10 }}>TIPS</span>
        <div className="line" />
      </div>
      <p className="h2" style={{ color: h2Color }}>
        即享直播页面，在线保存十年
      </p>
      <p className="h2" style={{ color: h2Color }}>
        右上角选收藏，微信随时查看
      </p>
      <p className="h1" style={{ color: h1Color, marginTop: 8 }}>
        即享影像，让分享更美
      </p>
    </div>
  );
};

export default ImageTips;
